import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import EjariActionSuccessPage from "../../Contract/EjariActionSuccessPage";
import { ManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps<any> {

}

interface State {

}

class CreateSuccess extends Component<Props, State> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	render() {
		const { action } = this.context;
		const isRenew = action === TenancyContactAction.RENEW_CONTRACT;
		const title = isRenew ? Strings.renew_management_contract : Strings.create_management_contract;
		const message = isRenew ? Strings.mc_renew_submitted : Strings.mc_create_submitted;
		return <EjariActionSuccessPage
			message={ message }
			title={ title }
			buttonTitle={ Strings.continue }
			refreshProperty={ true }
			{ ...this.props }
		/>;
	}
}

export default CreateSuccess;
